import { loadStripe } from "@stripe/stripe-js"

let stripePromise = null
let stripePublicKey = null

export function getStripePromise(publicKey = null) {
  if (!stripePromise || stripePublicKey !== publicKey) {
    stripePublicKey = publicKey
    stripePromise = loadStripe(publicKey)
  }

  return stripePromise
}